export default __webpack_public_path__ + "static/media/label.dd000a23.svg";